import { isLocalEnvironment } from 'init/proto_client';

export default function setCookie(name, value, days) {
  if (isLocalEnvironment()) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/; Secure`;
  } else {
    // console.log(`Cookie ${name} will be set by backend with proper security flags`);
  }
}
